<form [formGroup]="departmentsForm">
  <mat-card appearance="outlined" class="card">
    <div class="flex-row start-center gap-20">
      <mat-card-actions>
        <button
          matButton="elevated"
          color="primary"
          (click)="onAddDepartment()"
        >
          <mat-icon>add</mat-icon> <span i18n>Add Department</span>
        </button>
        <button matButton="elevated" (click)="onBack()">
          <mat-icon>arrow_back</mat-icon> <span i18n>Back</span>
        </button>
      </mat-card-actions>
    </div>
    <br />
    <mat-card-content>
      <mat-list>
        <div class="flex-row start-center">
          <h3 style="flex: 1 1 40%" i18n>Department Name</h3>
          <h3 style="flex: 1 1 40%" i18n="@@externalId">External Id</h3>
          <span style="flex: 1 1 10%" i18n="@@edit">Edit</span>
          <span style="flex: 1 1 10%" i18n="@@delete">Delete</span>
        </div>
        @for (dept of departments; track dept) {
        <mat-list-item>
          <div class="flex-row start-center">
            <p style="flex: 1 1 40%">{{ dept.name }}</p>
            <p style="flex: 1 1 40%">
              {{ dept.externalId ? dept.externalId : "-" }}
            </p>
            <mat-icon style="flex: 1 1 10%" (click)="updateDepartment(dept)"
              >edit</mat-icon
            >
            <mat-icon
              (click)="deleteDepartment(dept)"
              style="color: gray; flex: 1 1 10%"
              >delete</mat-icon
            >
            <mat-divider />
          </div>
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
</form>
